import { Plot } from "../models/Plot";

export class PlotSearchResult {
    constructor(
        public plotId: string,
        public plot: Plot,
        public path: Array<number>,
        public topLevelParent: Plot | undefined,
        public parent?: Plot
    ) { }
}

export class PlottingSearchService {

    public static findPlotByIdRecursive(
        plots: Plot[],
        targetId: string
    ): PlotSearchResult | null {
        return this.search(plots, targetId);
    }

    private static search(plots: Plot[],
        targetId: string,
        parent?: Plot,
        topLevelParent?: Plot,
        path: number[] = []
    ): PlotSearchResult | null {
        for (let i = 0; i < plots.length; i++) {
            const plot = plots[i];
            const currentPath = [...path, i];
            const currentTopLevel = topLevelParent ?? plot;

            if (plot.id === targetId) {
                return new PlotSearchResult(targetId, plot, currentPath, currentTopLevel, parent);
            }

            const nestedPlots = plot.configuration?.plots;
            if (Array.isArray(nestedPlots)) {
                throw new Error("Plots containing child plots is not supported.");
                //const result = this.search(nestedPlots, targetId, plot, currentTopLevel, currentPath);
                //if (result) return result;
            }
        }

        return null;
    }

    public static setPlotAtPath(
        topLevelParent: Plot,
        path: number[],
        newPlot: Plot
    ): boolean {
        if (path.length === 0) return false; // Nothing to replace

        let currentPlots = topLevelParent.configuration?.plots
        if (!Array.isArray(currentPlots)) return false;

        // Traverse to the parent of the target rule
        for (let i = 0; i < path.length - 1; i++) {
            const index = path[i];
            const plot = currentPlots[index];
            if (!plot?.configuration?.plots) return false;

            currentPlots = plot.configuration.plots;
        }

        const targetIndex = path[path.length - 1]

        // Replace the target rule
        if (currentPlots && currentPlots[targetIndex]) {
            currentPlots.splice(targetIndex, 1, newPlot)
            return true;
        }

        return false;
    }

}